import {error } from "console";

export const theme = {
  colors: {
    primary: '#007bff', // Standard blue
    primaryDark: '#0056b3', // Darker blue for hover
    // primaryLight: '#e6f7ff', // Lighter blue for outline hover background
    primaryLight: '#e6f7ff',
    secondary: '#6c757d', // Example grey for other secondary elements if needed
    secondaryDark: '#5a6268',
    accent: '#28a745', // Example green for a distinct secondary action if needed
    accentDark: '#218838',
    white: '#ffffff',
    text: '#333',
    textSecondary: '#666',
    border: '#ddd',
    borderLight: '#eee',
    danger: '#dc3545',
    primary_rgb: '0, 123, 255', 
    warning: '#ff9800',
    success: '#8bc34a',
    light: '#f2f2f2',
    dark: '#333333',
    // text: '#333333',
    textLight: '#666666',
    // white: '#ffffff',
    black: '#000000',
    error: '#f44336',
    errorBg:'#ffff' ,
    successLight: '8bc34a',
    // border: "#dee2e6",
    gray:"#808080",
   
    background: '#ADD8E6',
    lightback: '#e6f7ff',
    info: '#3498db',    
    infoLight: '#d9edf7',
    infoDark: '#2980b9',
    textDark: '#212529',
    secondaryLight: '#f1f8e9',
    dangerLight: '#ffebee',
    cardBackground: '#ffffff',
    textMuted: '#6c757d',
    lightHover: '#f0f0f0',
    darkHover: '#343a40',
    lightGrey: '#f8f9fa',
    darkGrey: '#343a40',
    textPrimary: '#212529',
    errorLight: '#ffebee',
    errorBackground: '#f8d7da',
    accentLight: '#ffccbc',
    accent_rgb: '255, 87, 34', 
    primaryRgb: '72, 201, 176',
    dangerDark: '#c62828',
   offWhite: '#f8f9fa', 
  },
  fonts: {
    main: 'Arial, sans-serif',
    code: 'monospace',
  },
  spacing: {
    xxs: '2px',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  typography: {
      fontFamily: "'Amazon Ember', Arial, sans-serif", // Or 'Roboto', 'Inter'
      headerFontFamily: "'Amazon Ember Display', Arial, sans-serif",
      lineHeight: 1.6,
      bodyFontSize: '1rem',
      smallFontSize: '0.875rem',
      subheading: '1.4rem', 
      largeFontSize: '1.125rem',
      caption: '0.75rem',
    },
   borderRadius: '8px', 
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', 
  transition: '0.2s ease-in-out',
};

